import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserPool from "../UserPool";
import { useAuthContext } from "../contexts/AuthContext";

const NewUser = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const { userEmail } = useAuthContext(); // Use the custom hook to get the user's email from context

  useEffect(() => {
    console.log("User Email from Context:", userEmail);

    // Check if the user is authenticated
    if (!userEmail) {
      // Redirect to the login page if not authenticated
      console.log("Redirecting to login - User not authenticated");
      navigate("/login");
    } else {
      console.log("User Email:", userEmail);

      // Check if the authenticated user's email matches the admin email
      const isAdmin = userEmail === "e939c9fe-5051-7033-c4b9-09cec376c399"; // Update with your admin email

      console.log("Is Admin:", isAdmin);

      if (isAdmin) {
        console.log("User is admin - Allow access");
      } else {
        // If not an admin, redirect to another page (e.g., home)
        console.log("Redirecting to home - User is not admin");
        navigate("/dashboard");
      }
    }
  }, [userEmail, navigate]);

  const onSubmit = (event) => {
    event.preventDefault();

    UserPool.signUp(email, password, [], null, (err, data) => {
      if (err) {
        console.error(err);
      }
      console.log(data);
    });
  };

  return (
    <div>
      <form onSubmit={onSubmit}>
        <label htmlFor="email">Email</label>
        <input
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        ></input>
        <label htmlFor="password">Password</label>
        <input
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        ></input>

        <button type="submit">Signup</button>
      </form>
    </div>
  );
};

export default NewUser;
